import API from '../portalApi';
const ENTITY = 'preview';

export const getProposalPreview = (proposalId) =>
    API.get(`/api/v1/${ENTITY}/${proposalId}/`);
